import _public from "./public";
import _private from "./private";

export const routes = [
  ..._public,
  ..._private,
];
